// @ts-strict

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpXsrfTokenExtractor
} from '@angular/common/http';

@Injectable()
export class HttpCSRFInterceptorService implements HttpInterceptor {

  constructor(private tokenExtractor: HttpXsrfTokenExtractor) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let requestToForward = request;

    if (request.method === 'POST') {
      const token = this.tokenExtractor.getToken() as string;
      if (token !== null) {
        requestToForward = request.clone({ setHeaders: { 'SSO.CSRF': token } });
      }
    }

    return next.handle(requestToForward);
  }
}
